import React from "react";

function getPerformanceAccentColor(value, ratio, fallbackColor) {
  if (value == null) return fallbackColor || "#cbd5e1";
  if (fallbackColor) return fallbackColor;
  if (ratio >= 0.8) return "#16a34a";
  if (ratio >= 0.6) return "#d97706";
  return "#dc2626";
}

export default function DonutChart({
  value,
  max = 100,
  size = 96,
  strokeWidth = 8,
  label,
  subLabel,
  accentColor,
  trackColor = "#e5e7eb",
  valueFormatter,
}) {
  const safeMax = max || 1;
  const raw = value ?? 0;
  const ratio = Math.max(0, Math.min(raw / safeMax, 1));
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - ratio);
  const resolvedAccentColor = getPerformanceAccentColor(value, ratio, accentColor);

  const displayValue =
    value == null
      ? "—"
      : valueFormatter
        ? valueFormatter(raw, safeMax)
        : `${Math.round(raw)}`;

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={trackColor}
          strokeWidth={strokeWidth}
          fill="none"
        />
        <g transform={`rotate(-90 ${size / 2} ${size / 2}) scale(1, -1) translate(0, -${size})`}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            stroke={resolvedAccentColor}
            strokeWidth={strokeWidth}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            // REMOVE the entire transform line from here
          />
        </g>
        <text
          x="50%"
          y="46%"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontSize: 14, fontWeight: 800, fill: "#111827" }}
        >
          {displayValue}
        </text>
        <text
          x="50%"
          y="62%"
          textAnchor="middle"
          dominantBaseline="middle"
          style={{ fontSize: 10, fill: "#6b7280" }}
        >
          {subLabel || ""}
        </text>
      </svg>
      {label && <div style={{ fontSize: 12, color: "#374151", fontWeight: 600 }}>{label}</div>}
    </div>
  );
}
